import { Http ,HttpFormType} from "../Http";
export class AddCorporateAPI {

    public static  getallCompanyAdditionalDetails(input: any){
      // getallCompanyAdditionalDetails
        var url = "api/getCompanyDetails/" + input.input;
 
    //   alert(JSON.stringify(input)); 
        if (input === "") {
          return { data: [] };
        }
    
        const resultMethod = Http.axios()
          .get(url, {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            }
          })
          .then(res => {
        //    alert(JSON.stringify(res));
            return res;
          })
          .catch((e: any) => {
            return e.response;
          });
        
        return resultMethod;  
    }

    public static saveCompanyAdditionalDetails(input: any) {
 
        var obj=JSON.stringify(input);
        var url="api/saveCorporateDetails";
 
       
        const resultMethod = Http.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
        
            return res;
          }).catch((e: any) => {
          
            return e.response;
          });
        return resultMethod;
}

 

public static addCompanDetails(input: any) {
 
  var obj=JSON.stringify(input);
  var url="api/addNewCompanyDetails";
  
 const resultMethod = Http.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
    
      return res;
    }).catch((e: any) => {
 
      return e.response;
    });  
  return resultMethod; 
}

public static addCorporateDetails(input: any) {
 
  var obj=JSON.stringify(input);
  var url="formtypes/createVmCompanyProfile";
  
  var userInputInit={
    companyCode:input.employerCode,
    companyName:input.employerName,
   // description:input.,
	  address1:input.streetName,
	  address2:input.aptSteFlrNumber,
	  city:input.city,
	  state:input.state,
	 // country:input.,
	  zipCode:input.zipCode,
	  //status:input.,
	  aptSteFlr:input.aptSteFlr,
    vmCompanyAddDetails:{
      phoneCountryCode:input.phoneCountryCode,
      phoneNumber:input.daytimePhoneNumber,
      fein:input.fein,
    //  mobilenNmber:input.,
      emailId:input.emailId,
      attnFirstName:input.attnFirstName,
      attnLastName:input.attnLastName,
      attnMiddleName:input.attnMiddleName,
      dateOfIncor:input.dateOfIncor,
      businessType:input.typeOfBusiness,
      naicsCode:input.naicsCode,
      netIncome:input.netIncome,
      noOfEmployees:input.noOfEmployees,
      noOfH1bEmployees:input.noofH1bEmployees,
     // noOfL1aAndL1bEmployees:input.,
      alternateEmailId:input.alternateEmailId,
      signFirstName:input.signFirstName,
      signLastName:input.signLastName,
      signMiddlename:input.signMiddleName,
      signTitleName:input.signTitle,
      aboutCompany:input.aboutCompany,
      h1bDependent:input.isEmprH1bDependent,
      violator:input.isEmprViolator,
      inHouseAttorney:input.isEmprAtorney,
      grossIncome:input.grossIncome,
      faxNumber:input.faxNumber,
      extention:input.extention,
      subcriptionName:input.subcriptionname
    
          },
      vmCompanyH1bQuestions:{
        h1bDependent:input.h1bdependent,
        willfulViolator:input.willfulviolator,
      moreThan50PerUS:input.morethan50perUS,
       moreThan50PerH1bL1a:input.morethan50perh1bl1a,
      higherEducationInstitution:input.highereducationinstitution,
      nonProfitOrganization:input.nonprofitorganization,
      nonProfitResearchOrganization:input.nonprofitresearchorganization,
      subsequentRequestExtension:input.subsequentrequestextension,
      amendedPetition:input.amendedpetition,
      correctUscisError:input.correctusciserror,
      secondaryEducationInstitution:input.secondaryeducationinstitution,
       nonProfitEntity:input.nonprofitentity
        
          }

        }
       
        obj =JSON.stringify(userInputInit);
        
      const resultMethod = HttpFormType.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
 
            return res;
          }).catch((e: any) => {
       
            return e.response;
          });
        return resultMethod; 
 
}

public static updateCorporateDetail(input: any) {
 
 
        var obj=JSON.stringify(input);
       
        var url="formtypes/updateVmCompanyProfile";
     
      const resultMethod = HttpFormType.axios().put(url, obj,
          {
            headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
   
      return res;
    }).catch((e: any) => {
     
      return e.response;
    });
  return resultMethod; 
}


 
}
